import React, { } from 'react'

const PrivacyPolicy = () => {
    return (
        <section id='privacy-policy'>
            <div className='legal-header'>
                <h6>Trench Warfare: World War</h6>
                <h1>Privacy Policy</h1>
            </div>
            <div className='text-panel'>
                <div className='date'>Effective date: April 25, 2025</div>
                <br />
                Thank you for playing Trench Warfare: World War ("the Game"), developed by Bati Games.
                <br />
                We respect your privacy and are committed to protecting your personal information. This Privacy Policy explains what data is collected when you use the Game, how it is used, and your rights regarding that data.
                <br />
                <div className='point-title'>1. Data We Collect</div>
                <br />
                We do not collect any personal data directly.
                <br />
                However, our third-party partners may collect data to provide services such as ads and in-app purchases:
                <br />
                Unity Ads and IronSource Ads may collect:<br />
                - Advertising ID<br />
                - Device information (e.g., device type, OS version)<br />
                - Approximate location (based on IP address)<br />
                - Interaction data (e.g., ad impressions, clicks)<br />
                <br />
                Unity In-App Purchasing (Unity IAP) may collect:
                Purchase data necessary to process transactions (handled via platform stores such as Google Play or Apple App Store)
                For more details, please refer to:
                <br />
                - <a href='https://unity.com/legal/privacy-policy' target='_blank'>Unity Privacy Policy</a>
                <br />
                - <a href='https://unity.com/legal/privacy-policy' target='_blank'>IronSource Privacy Policy</a>
                <br />
                <div className='point-title'>2. How We Use Data</div>
                <br />
                Any data collected by third-party services is used for:
                <br />
                - Delivering personalized or contextual ads<br />
                - Providing analytics to improve game performance and ad relevance<br />
                - Handling secure in-app purchases<br />
                <br />
                We do not process or store this data ourselves.
                <br />
                <div className='point-title'>3. Storage Access</div>
                <br />
                The game may request access to your device's storage to:
                <br />
                - Save game progress and local settings in its own app folder<br />
                - No personal files or data are accessed<br />
                <div className='point-title'>4. Children’s Privacy</div>
                <br />
                We do not knowingly collect any personal information from children under 13 in the US or under the relevant age threshold in other jurisdictions.
                <br />
                <div className='point-title'>5. Your Choices</div>
                <br />
                You can control your data in the following ways:
                <br />
                Opt-out of personalized ads through your device’s ad settings
                Deny storage permission (some game features may be limited)
                <div className='point-title'>6. Contact Us</div>
                <br />
                If you have questions or concerns about this policy, please contact us at: batigamesofficial@gmail.com
            </div>
        </section>
    )
}

export default PrivacyPolicy;